/**
 * 管理端  客户管理
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <agentNav></agentNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top" style="font-size: 14px;">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>案件列表</div>
            <!-- <div class="eval-con-btn" style="margin-left: auto;">表格导出</div> -->
            <div class="eval-con-search" style="margin-left: auto;">
               <el-input v-model="formInline.keyword" placeholder="请输入关键词" clearable>
                  <!-- <template slot="append" style="color: #ffffff;">搜索</template> -->
                  <el-button slot="append" @click="checkSearch()">搜索</el-button>
               </el-input>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="caseData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="type" align="center" label="专利类型" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="area" align="center" label="专利领域" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="status" align="center" label="案件状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.status == 1">待评测</span>
                  </template>
               </el-table-column>
               <el-table-column prop="start_time" align="center" label="分配时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="end_time" align="center" label="截止时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作" min-width="120">
                  <template slot-scope="scope">
                     <el-button size="mini" style="background-color: #2A91DD;" type="primary" @click="writeCase(scope.index, scope.row)">撰写</el-button>
                     <el-button size="mini" type="danger" @click="backCase(scope.index, scope.row)">回退</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </div>
      </div>
    </div>
 </template>
 <script>
   import { 
      getAgentCaseTask,
      backCaseTask
   } from '../../api/evalMG'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import agentNav from '../../components/agentNav'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            loading: false,
            caseData: [],
            formInline: {
               page: 1,
               ps: 10,
               keyword: ''
            },
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         agentNav
      },
      created(){
         this.getCaseData()
      },
      methods: {
         checkType(val){
            this.applyForm.type = val
         },
         checkArea(val){
            this.applyForm.area = val
         },
         // 跳转待评估案件
         jumpWait(){
            this.$router.push({ path: '/agent/waitEval'});
         },
         // 跳转专家撰写
         jumpWrite(){
            this.$message({
               type: 'warning',
               message: '请选择需要撰写的案件'
            })
            // this.$router.push({ path: '/agent/writeEval'});
         },
         // 跳转评估记录
         jumpEvalRecord(){
            this.$router.push({ path: '/agent/agentEvalRecord'});
         },
         // 跳转个人中心
         jumpPersonCenter(){
            this.$router.push({ path: '/agent/agentPersonCenter'});
         },
         // 点击搜索
         checkSearch(){
            this.getCaseData()
         },
         // 查询案件数据
         getCaseData(){
            this.loading = true
            getAgentCaseTask(this.formInline)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.caseData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.loading = false
               }
            })
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
         },
         // 撰写案件
         writeCase(index,row){
            let id = row.task_id
            // 跳转撰写页面,传递id
            this.$router.push({ path: '/agent/writeEval',query: {id:id }});
         },
         // 回退案件
         backCase(index,row){
            let task_id = row.task_id
            this.$confirm('确定要回退案件?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let param = {
                  task_id: task_id
               }
               backCaseTask(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.getCaseData()
                  }else{
                     this.$message({
                        type: 'warning',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         }
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .login-title {
    font-size: 44px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   /* border-bottom: 2px solid #eeeeee; */
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 100px;
   height: 36px;
   line-height: 36px;
   text-align: center;
   color: #fff;
   background-color: #2A91DD;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search {
   margin-left: 20px;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }
</style>


// WEBPACK FOOTER //
// src/views/agent/waitEval.vue